import { Directive, Host, Inject, Input, NgIterable } from '@angular/core'
import { NgForOf } from '@angular/common'

@Directive({
    selector: '[ngForTrackByProperty]',
    standalone: false
})
export class NgForTrackByPropertyDirective<T> {

    @Input() ngForOf!: NgIterable<T>
    @Input() ngForTrackByProperty!: keyof T

    constructor(@Host() @Inject(NgForOf) ngForOfDir: NgForOf<T>) {
        ngForOfDir.ngForTrackBy = (_, item: T): T[keyof T] => item[this.ngForTrackByProperty]
    }
}

@Directive({
    selector: '[ngForTrackByIndex]',
    standalone: false
})
export class NgForTrackByIndexDirective<T> {

    @Input() ngForOf!: NgIterable<T>

    constructor(@Host() @Inject(NgForOf) ngForOfDir: NgForOf<T>) {
        ngForOfDir.ngForTrackBy = (index: number): number => index
    }
}

@Directive({
    selector: '[ngForTrackById]',
    standalone: false
})
export class NgForTrackByIdDirective<T extends { id: number | string }> {

    @Input() ngForOf!: NgIterable<T>

    constructor(@Host() @Inject(NgForOf) ngForOfDir: NgForOf<T>) {
        ngForOfDir.ngForTrackBy = (_, item: T): number | string => item.id
    }
}